module.exports = __webpack_public_path__ + "static/2_1_search-2_PL-7d4df9713fe491b37e1ca70ffc430572.svg";